import _objectWithoutProperties from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["bounds", "url"];
import { createElementObject, createLayerComponent, extendContext, updateMediaOverlay } from '@react-leaflet/core';
import { VideoOverlay as LeafletVideoOverlay } from 'leaflet';
export var VideoOverlay = createLayerComponent(function createVideoOverlay(_ref, ctx) {
  var bounds = _ref.bounds,
    url = _ref.url,
    options = _objectWithoutProperties(_ref, _excluded);
  var overlay = new LeafletVideoOverlay(url, bounds, options);
  if (options.play === true) {
    var _overlay$getElement;
    (_overlay$getElement = overlay.getElement()) === null || _overlay$getElement === void 0 || _overlay$getElement.play();
  }
  return createElementObject(overlay, extendContext(ctx, {
    overlayContainer: overlay
  }));
}, function updateVideoOverlay(overlay, props, prevProps) {
  updateMediaOverlay(overlay, props, prevProps);
  if (typeof props.url === 'string' && props.url !== prevProps.url) {
    overlay.setUrl(props.url);
  }
  var video = overlay.getElement();
  if (video != null) {
    if (props.play === true && !prevProps.play) {
      video.play();
    } else if (!props.play && prevProps.play === true) {
      video.pause();
    }
  }
});